import React from 'react';
import { IMAGE_CDN_URL } from '../../../../utilities/imageCDN';

export const cloudinaryBaseURL = (color) =>
    `${IMAGE_CDN_URL}/fl_sanitize,c_scale,co_rgb:${color},e_colorize:100,f_png,w_48,h_48/v1/`;

export const iconSVGs = {
    comment: (baseURL) => ({
        false: `${baseURL}reactionBarIcons/comment-mail-08.svg`,
        true: `${baseURL}reactionBarIcons/comment_active.svg`,
    }),
    flag: (baseURL) => ({
        false: `${baseURL}reactionBarIcons/flag-nature-15.svg`,
        true: `${baseURL}reactionBarIcons/flag_active.svg`,
    }),
    interested: (baseURL) => ({
        false: `${baseURL}reactionBarIcons/Interested_inactive.svg`,
        true: `${baseURL}reactionBarIcons/interested_active.svg`,
    }),
    like: (baseURL) => ({
        false: `${baseURL}reactionBarIcons/like-inactive.svg`,
        true: `${baseURL}reactionBarIcons/like-activated.svg`,
    }),
    share: (baseURL) => ({
        false: `${baseURL}reactionBarIcons/share-mail-18.svg`,
        true: `${baseURL}reactionBarIcons/share-mail-18.svg`,
    }),
    edit: (baseURL) => ({
        false: `${baseURL}reactionBarIcons/edit_pencil.svg`,
        true: `${baseURL}reactionBarIcons/edit_pencil.svg`,
    }),
    delete: (baseURL) => ({
        false: `${baseURL}reactionBarIcons/delete_trash.svg`,
        true: `${baseURL}reactionBarIcons/delete_trash.svg`,
    }),
};
